import logo from './logo.svg'
import styles from './gameHeader.module.scss'

const GameHeader = ({ clickHandler }) => {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="/" title="Home page" className={styles.link}>
          <img src={logo} alt="Checkers online" />
        </a>
        <i className={styles.icon} onClick={clickHandler} />
      </div>
    </header>
  )
}

export default GameHeader
